module.exports = __webpack_public_path__ + "img/icon-shaitongzhishu@2x.7d69935c.png";